import React from "react"

import { useStyles } from "@/components/ProfileDivider/ProfileDivider.styles"

export const ProfileDivider = () => {
    const { classes } = useStyles()

    return <hr className={classes.divider} />
}
